<template>
  <article class="search-result-spec flex-row">
    <figure>
      <SloIcon name="FileArrowDown" />
    </figure>
    <div>
      <h3>
        <a
          :href="'/spec-sheet/' + item.variation_sku"
          @click="sendEvent('click', item, 'Global Search Spec Sheet Result Clicked')"
        >
          <ais-highlight :hit="item" attribute="variation_title" />
        </a>
      </h3>
      <div class="my-sm c-gray-600">
        <ais-highlight :hit="item" attribute="variation_sku" />
      </div>
      <p v-if="item.variation_description" class="text-sm c-gray-800">
        <ais-highlight :hit="item" attribute="variation_description" />
      </p>
    </div>
  </article>
</template>

<script>
import SloIcon from '../../../lib/components/SloIcon.vue';

export default {
  components: {
    SloIcon
  },
  props: ['item', 'sendEvent']
};
</script>

<style lang="scss">
@import '../../../scss/system';
@import '../../../scss/mixins';

.search-result-spec {
  figure {
    width: 4.5rem;
    height: 4.5rem;
    margin-right: 1.25em;
    flex-shrink: 0;
    text-align: center;
  }

  figure .slo-icon, figure svg {
    width: 100%;
    height: 100%;
    color: $color-gray-500;
  }
}
</style>
